export default __webpack_public_path__ + "static/media/banner-image_brick-project.c19dfe0e.png";